angular.module('dnecom').controller('CampaignStatisticsController', ["$scope", "$http", "StatisticsTabs", "notifications", function($scope, $http, StatisticsTabs, notifications) {
    $scope.store = TemplateData.value('store');
    $scope.campaign = TemplateData.value('campaign');
    $scope.summary = StatisticsTabs;
    $scope.statistics = StatisticsTabs.createInstance();

    $scope.period = 'last-month';
    $scope.emailId = '0';

    $scope.init = {
        summary: function(data) {
            $scope.summary.$tabs = [{items: data}];
            $scope.summary.change(0);
        },
        statistics: function(data) {
            $scope.statistics.$tabs = [{items: data}];
            $scope.statistics.change(0);
        },
        charts: function(data) {
            var datasets = [];
            var sections = [
                {label: 'Delivered', color: '#48B0F7'},
                {label: 'Clicked', color: '#10CFBD'}
            ];

            _.each(sections, function(section) {
                datasets.push({
                    label: section.label,
                    data: _.map(data, section.label.toLowerCase()).map(function(count) {
                        return parseInt(count) || 0;
                    }),
                    borderColor: section.color,
                    backgroundColor: section.color,
                    lineTension: 0,
                    fill: false
                });
            });

            $scope.crtChartData = {
                labels: _.map(datasets, 'label'),
                datasets: [
                    {
                        data: _.map(_.map(datasets, 'data'), function(items) {
                            return _.reduce(items, function(a, b) {
                                return a + b;
                            });
                        }),
                        backgroundColor: _.map(datasets, 'backgroundColor')
                    }
                ]
            };

            $scope.crtGraphData = {
                labels: _.keys(data),
                datasets: datasets
            };
        }
    };

    $scope.apply = function() {
        $http
            .post(Routing.generate('campaign_statistics_charts', {
                store: $scope.store.id,
                campaign: $scope.campaign.id,
            }), {
                period: $scope.period,
                start: $scope.dateFrom,
                end: $scope.dateTo,
                emailId: $scope.emailId
            })
            .then(function(response) {
                $scope.init.charts(response.data.charts);
                $scope.init.summary(response.data.summary);
                $scope.init.statistics(response.data.statistics);
            }, notifications.fromResponse);
    };

    $scope.crtChartOptions = {
        legend: {
            position: 'bottom'
        }
    };

    $scope.crtGraphOptions = {
        legend: {
            display: false
        }
    };

    $scope.apply();
}]);
